import {Base64Object, validateBase64ObjectFileSize} from '@coolcolduk/util';
import {env} from '../../config/env';
import deleteStorageFilesByPrefix from '../../helper/firebase/storage/deleteStorageFilesByPrefix';
import uploadStorageBase64 from '../../helper/firebase/storage/uploadStorageBase64';
import extractFileExtension from '../../utils/file/extractFileExtension';

/**
 * Uploads background image to Storage and returns the download URL.
 * deletes any existing background image before uploading the new image.
 * Caller should update user doc with backgroundImageUrl or deleteField() when clearing.
 */
export default async function uploadUserBackgroundImage(
  uid: string,
  backgroundImage: Base64Object | undefined,
): Promise<string | undefined> {
  await deleteStorageFilesByPrefix(`private/${uid}`, 'background');
  if (!backgroundImage) {
    return undefined;
  }
  validateBase64ObjectFileSize(
    backgroundImage,
    env.sizeLimit.background,
    `Background image size exceeds limit of ${env.sizeLimit.background} bytes`,
  );
  const ext = extractFileExtension(backgroundImage.name);
  const path = `private/${uid}/background.${ext}`;
  return uploadStorageBase64(backgroundImage, path);
}
